module.exports = __webpack_public_path__ + "img/动画1.56d4bfc7.gif";